import { render } from "./ReserveOrder.vue?vue&type=template&id=c1f4d888&scoped=true&ts=true"
import script from "./ReserveOrder.vue?vue&type=script&lang=ts"
export * from "./ReserveOrder.vue?vue&type=script&lang=ts"

import "./ReserveOrder.vue?vue&type=style&index=0&id=c1f4d888&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f4d888"]])

export default __exports__